module.exports = __webpack_public_path__ + "static/media/live.49350b3b.svg";